"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const smallBreakPoint = '400px';
const midBreakPoint = '780px';

const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;margin:2rem 3rem;flex-wrap:wrap;@media(max-width:", "){margin:0 0.5rem;}"], smallBreakPoint);

const BodyText = _styledComponents.default.p.withConfig({
  displayName: "BodyText"
})(["font-family:", ";margin:0;display:flex;flex:5;min-width:320px;@media(max-width:", "){padding:1rem;margin:0;}"], ({
  theme
}) => theme.fonts.secondary, midBreakPoint);

const ActionWrap = _styledComponents.default.div.withConfig({
  displayName: "ActionWrap"
})(["margin:0 1.5rem;display:flex;flex:1;min-width:320px;@media(max-width:", "){margin:0;padding:1rem 0;}"], midBreakPoint);

var _default = {
  Wrapper,
  BodyText,
  ActionWrap
};
exports.default = _default;